import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    changeInsuranceInitialState,
    handlePaginationStateInsurance,
    updateFiltersInsurance,
    resetFiltersInsurance,
    setSelectedInsurance,
    setShowInsuranceDetails,
} from "../../../store/insurance/insuranceSlice";

const mapStateToProps = (state) => {
    return {
        // insurance
        formType: state.insurance.formTypeInsurance,
        initialValues: state.insurance.initialValuesInsurance,
        showDrawer: state.insurance.showDrawerInsurance,
        pagination: state.insurance.paginationInsurance,
        filters: state.insurance.filtersInsurance,
        selectedInsurance: state.insurance.selectedInsurance,
        showInsuranceDetails: state.insurance.showInsuranceDetails,
    };
};

const mapDispatch = {
    changeInsuranceInitialState,
    handlePaginationState: handlePaginationStateInsurance,
    updateFilters: updateFiltersInsurance,
    resetFilters: resetFiltersInsurance,
    setSelectedInsurance,
    setShowInsuranceDetails,
};

const mapDispatchToProps = (dispatch) => bindActionCreators(mapDispatch, dispatch);

const Store = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
